import { createFileRoute } from "@tanstack/react-router";
import Inicio from "@/pages/app/Inicio";

export const Route = createFileRoute("/app/")({
  head: () => ({ meta: [{ title: "Início | Braussie - Nutri" }] }),
  component: Inicio,
});
